import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Global Members/HTML DOM/confirm.md";
import * as React from 'react';
export default {
  Content,
  React
};